<template>
  <div :style="{textAlign: this.align}">
    <a href="#" @click="facebookShare">
      <img src="/images/sns/Facebook_Logo_Primary.png" alt="Facebook Share" width="30" />
    </a>
    <a href="#" @click="twitterShare">
      <img src="/images/sns/x-logo-black.png" alt="X Share" width="30" style="padding:3px" />
    </a>
    <a href="#" @click="lineShare">
      <img src="/images/sns/LINE_APP_Android.png" alt="Line Share" width="30" />
    </a>
  </div>
</template>

<script>
export default {
  name: 'SnsShare',
  props: {
    url: {
      type: String,
      required: true
    },
    align : {
      type: String,
      default: 'center'
    }
  },
  methods: {
    facebookShare() {
      window.open('https://www.facebook.com/sharer/sharer.php?u=' + this.url);
    },
    twitterShare() {
      window.open('https://twitter.com/intent/tweet?url=' + this.url);
    },
    lineShare() {
      window.open('https://social-plugins.line.me/lineit/share?url=' + this.url);
    }
  }
}
</script>

<style scoped>
a {
  margin: 0 10px;
}
</style>